// extracted by mini-css-extract-plugin
export default {"countBadge":"countBadge---XyBg1","linkText":"linkText---OlG8K","spinner":"spinner---SAp8a"};